<template>
    <div>
        <Leftmenu />
        <Header />
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="content-header">
                <Backbutton />
                Редактировать сотрудника
            </div>
             <div class="content-inner">
                <div class="header-for-input">Является членом команды КЦОП</div>
                <input type="checkbox" v-model="user.in_kcop_team" />
                <div v-show="user.in_kcop_team" class="header-for-input">Роль в команде КЦОП</div>
                <select v-show="user.in_kcop_team" class="content-input input_width_50" v-model="user.user_role_in_kcop">
                    <option value="0">Не выбрано</option>
                    <option v-for="position, key in refbook_kcop_data" :key="key" :value="key">{{position}}</option>
                </select>

                <div class="btn_main_button" @click="save_user_kcop_data()">Сохранить</div>
             </div>
        </div>
    </div>
</template>

<script>
import Leftmenu from '@/components/leftmenu.vue'
import Header from '@/components/header.vue'
import Backbutton from '@/components/elements/bacl-button.vue'
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'Addusertocompany',
    props: {
        id: String,
        user_id: String
    },
    components: {
        Leftmenu, Header, Backbutton, Success, Error
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            user: {
                in_kcop_team: false,
                user_role_in_kcop: 0
            },
            refbook_kcop_data: {}
        }
    },
    methods: {
        refbook_kcop() {
            //refbook_kcop
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/refbook_kcop')
            .then(response => {
                this.refbook_kcop_data = response.data.data
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
            });
        },
        get_user_kcop_data() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/user_kcop_data/'+this.id+'/'+this.user_id)
            .then(response => {
                let in_kcop_team = response.data.data.in_kcop_team
                if(in_kcop_team == 0) 
                    this.user.in_kcop_team = false
                else
                    this.user.in_kcop_team = true
                this.user.user_role_in_kcop = response.data.data.user_role_in_kcop
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
            });
        },
        save_user_kcop_data() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.post(process.env.VUE_APP_API_URL + '/api/save_user_kcop_data/'+this.id+'/'+this.user_id, this.user)
            .then(() => {
                //this.user = response.data.data
                this.get_user_kcop_data()
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
            });
        },
    },
    created() {
        this.refbook_kcop()
        this.get_user_kcop_data()
    }
}
</script>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>